﻿export interface ElevenLabsWidgetProps {
  agentId: string;
  variant: 'compact' | 'expanded';
  className?: string;
  style?: React.CSSProperties;
}

/** Legacy decks link to authenticated voice; a public agent ID never starts a conversation. */
const ElevenLabsWidget = ({ className = '', style = {} }: ElevenLabsWidgetProps) => (
  <div className={`flex items-center justify-center ${className}`} style={style}>
    <a href="/private" className="rounded-lg bg-white/10 px-5 py-3 text-center text-white">
      Open EVA in de privépresentatie
    </a>
  </div>
);

export default ElevenLabsWidget;
